/*
 Row Provider plugin suggested by DevExpress
 because GridExporter does not apply custom filters
 https://supportcenter.devexpress.com/ticket/details/t1006121/reactive-grid-the-cannot-read-property-rows-of-undefined-error-appears-on-exporting-data
*/

import PropTypes from 'prop-types';
import {Plugin, Getter} from '@devexpress/dx-react-core';

const handleRowsGetter =
  (onRowsUpdate) =>
  ({rows}) => {
    setTimeout(() => onRowsUpdate(rows));

    return rows;
  };

export default function RowsProvider({onRowsUpdate}) {
  const handleRows = handleRowsGetter(onRowsUpdate);

  return (
    <Plugin>
      <Getter name="rows" computed={handleRows} />
    </Plugin>
  );
}

RowsProvider.propTypes = {
  onRowsUpdate: PropTypes.func.isRequired,
};
